<template>
  <div>
    <BaseHeadline :showOnMobile="true" icon="mdi-view-dashboard">
      <template v-slot:headlineBtns>
        <v-btn
          v-if="!$vuetify.breakpoint.smAndDown"
          class="mr-3 mb-0"
          color="primary"
          depressed
          :to="{ name: 'Aberration' }"
        >
          <v-icon left> mdi-progress-wrench </v-icon>
          Nytt avvik
        </v-btn>
        <v-btn
          v-if="!$vuetify.breakpoint.smAndDown"
          class="mr-3 mb-0"
          color="primary"
          depressed
          @click="showRHorRODialog = true"
        >
          <v-icon left> mdi-alert-octagram-outline </v-icon>
          HMS-rapport
        </v-btn>
      </template>
    </BaseHeadline>

    <BaseView v-model="list">
      <template v-slot="{ element }">
        <DashboardShortcuts v-if="element.type === 'DashboardShortcuts'" />
        <DashboardButtons
          class="mb-2"
          v-if="element.type === 'DashboardButtons'"
        />

        <DashboardProjects
          v-if="element.type === 'DashboardProjects'"
          :fullWidth="$vuetify.breakpoint.sm ? false : true"
        />

        <DashboardComplaints
          v-if="element.type === 'DashboardComplaints'"
          title="Reklamasjoner"
          icon="mdi-clipboard-alert-outline"
          :isEnquiry="false"
        />
        <DashboardComplaints
          v-if="element.type === 'DashboardEnquiry'"
          title="Hendvendelser"
          icon="mdi-message-text-outline"
          isEnquiry
        />
        <DashboardMeasures v-if="element.type === 'DashboardMeasures'" />
        <DashboardCheckups v-if="element.type === 'DashboardCheckups'" />
        <DashboardChecklists
          v-if="element.type === 'DashboardChecklists' && isTrysilhus"
        />
      </template>
    </BaseView>

    <RHorRODialog v-model="showRHorRODialog" />
  </div>
</template>

<script lang="js">
import Vue from "vue";
import { mapGetters } from "vuex"
import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import BaseView from "@/components/shared/BaseView.vue";
import DashboardShortcuts from "@/components/dashboard/DashboardShortcuts.vue";
import DashboardButtons from "@/components/dashboard/DashboardButtons.vue";
import DashboardProjects from "@/components/dashboard/DashboardProjects.vue";
import DashboardComplaints from "@/components/dashboard/desktop/DashboardComplaints.vue";
import DashboardMeasures from "@/components/dashboard/desktop/DashboardMeasures.vue";
import DashboardCheckups from "@/components/dashboard/desktop/DashboardCheckups.vue";
import DashboardChecklists from "@/components/dashboard/desktop/DashboardChecklists.vue";
import RHorRODialog from "@/components/aberration/new/children/RHorRODialog.vue";

export default Vue.extend({
  name: "Dashboard",
  data() {
    return {
      isLoading: false,
      pStart: { x: 0, y: 0 },
      pCurrent: { x: 0, y: 0 },
      cards: null,
      main: null,

       list: {
        lg: [
          [{ type: "DashboardProjects" }],
          [{ type: "DashboardComplaints" }, { type: "DashboardEnquiry" }],
          [{ type: "DashboardMeasures" }, { type: "DashboardCheckups" }, { type: "DashboardChecklists" }],
        ],
        md: [
          [{ type: "DashboardProjects" }],
          [{ type: "DashboardComplaints" }, { type: "DashboardEnquiry" }],
          [{ type: "DashboardMeasures" }, { type: "DashboardCheckups" }, { type: "DashboardChecklists" }],
        ],
        sm: [
          [
            { type: "DashboardShortcuts" },
            { type: "DashboardButtons" },
            { type: "DashboardProjects" }
          ],
        ],
      },
      showRHorRODialog: false,
    };
  },


  mounted() {
    this.cards = document.querySelectorAll(".card");
    this.main = document.querySelector("body > div");

    document.addEventListener("touchstart", (e) => this.swipeStart(e), false);
    document.addEventListener("touchmove", (e) => this.swipe(e), false);
    document.addEventListener("touchend", (e) => this.swipeEnd(e), false);
  },
  methods: {
    loading() {
      this.isLoading = true;
      // this.main.style.transform = `translateY(0px)`;
      setTimeout(() => {
        // this.main.style.transform = `translateY(-100px)`;
        this.isLoading = false;
        for (const card of this.cards) {
          card.style.transform = `rotateX(0deg)`;
        }
      }, 2000);
    },

    swipeStart(e) {
      if (typeof e["targetTouches"] !== "undefined") {
        let touch = e.targetTouches[0];
        this.pStart.x = touch.screenX;
        this.pStart.y = touch.screenY;
      } else {
        this.pStart.x = e.screenX;
        this.pStart.y = e.screenY;
      }
    },
    swipeEnd() {
      if (document.body.scrollTop === 0 && !this.isLoading) {
        for (const card of this.cards) card.style.transform = `rotateX(0deg)`;
      }
    },
    swipe(e) {
      if (typeof e["changedTouches"] !== "undefined") {
        let touch = e.changedTouches[0];
        this.pCurrent.x = touch.screenX;
        this.pCurrent.y = touch.screenY;
      } else {
        this.pCurrent.x = e.screenX;
        this.pCurrent.y = e.screenY;
      }
      let changeY = this.pStart.y < this.pCurrent.y ? Math.abs(this.pStart.y - this.pCurrent.y) : 0;
      const rotation = changeY < 100 ? changeY * 30 / 100 : 30;
      if (document.body.scrollTop === 0) {
        if (changeY > 100) this.loading();
        for (const card of this.cards) card.style.transform = `rotateX(${rotation}deg)`;
      }
    },
  },
  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
    }),
  },
  components: {
    BaseView,
    BaseHeadline,
    DashboardShortcuts,
    DashboardButtons,
    DashboardProjects,
    DashboardComplaints,
    DashboardMeasures,
    DashboardCheckups,
    DashboardChecklists,
    RHorRODialog
  },
});
</script>
